<template>
    <router-link to="/hkcmnews" class="lg:flex flex-row gap-8 items-center justify-between">
        <img class="h-12 object-contain" :src="$asset('/hkcm/images/hkcm-news.png', 'public')" alt="HKCM News Logo"
            title="HKCM News Logo" />
        <p class="lg:text-2xl text-blue">{{ $t('news_independent') }}. {{ $t('news_relevant') }}. {{ $t('news_critical')
            }}.</p>
    </router-link>
</template>
